import { addDays, addYears, format, isValid, parseISO } from "date-fns";
import * as dateFnsLocales from "date-fns/locale";

export const defaultDateFormat = (date: Date, dateFormat = "dd/MM/yyyy") => {
    if (!date || !isValid(date)) return "";

    return format(date, dateFormat);
};
export const resetTime = (date: Date): Date => {
    if (!date || !isValid(date)) return date;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const getTodaysDate = (): Date => {
    return resetTime(new Date());
};

export const dateLocales: { [x: string]: Locale } = {
    en: dateFnsLocales.enUS,
    fr: dateFnsLocales.fr,
    nl: dateFnsLocales.nl,
    de: dateFnsLocales.de,
};

export const chatDateFormat = (date: Date, lang: string): string | null => {
    if (date) {
        return format(date, "EEE, dd MMM yyyy, HH:mm ", { locale: dateLocales[lang] });
    }
    return null;
};

export const formatDueDate = (datePattern: string): string => {
    if (!datePattern) return "";

    const dd = datePattern.substring(2, 4);
    const mm = datePattern.substring(0, 2);
    return `${dd}/${mm}`;
};

export const formatDueDateDDMM = (datePattern: string): string => {
    if (!datePattern) return "";

    const mm = datePattern.substring(2, 4);
    const dd = datePattern.substring(0, 2);
    return `${dd}/${mm}`;
};

export const nextDayOf = (date: Date): Date => (isValid(date) ? addDays(new Date(date), 1) : date);

function pad(number) {
    return String(number).padStart(2, "0");
}

export const formatTime = (value: Date): string => {
    return pad(value.getHours()) + ":" + pad(value.getMinutes());
};

// Convert to full year: 22 => 2022, 99 => 1999
export const convertDateToFullYear = (value: Date): Date => {
    if (!value || !isValid(value) || value.getFullYear() > 100) {
        return value;
    }

    const actualYear2Digits = new Date().getFullYear() % 100;
    const yearsToAdd = actualYear2Digits >= value.getFullYear() ? 2000 : 1900;
    const newValue = addYears(value, yearsToAdd);

    return newValue;
};

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

function isIsoDateString(value: any): boolean {
    return value && typeof value === "string" && isoDateFormat.test(value);
}

// Parse string dates to Date objects
export const handleStringDates = (body: any) => {
    if (body === null || body === undefined || typeof body !== "object") return body;

    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) body[key] = parseISO(value);
        else if (typeof value === "object") handleStringDates(value);
    }
    return body;
};

export function convertStringDates(body: any) {
    handleStringDates(body);
    return body;
}

declare global {
    interface Date {
        toBeDateFormat(): string;
    }
}

Date.prototype.toBeDateFormat = function (): string {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return [this.getFullYear(), pad(this.getMonth() + 1), pad(this.getDate())].join("-");
};

// Stringify Date objects to string dates on YYYY-MM-DD format
export const handleDatesString = (body: any) => {
    if (body === null || body === undefined || typeof body !== "object") return body;

    for (const key of Object.keys(body)) {
        const value = body[key];
        if (value instanceof Date) body[key] = value.toBeDateFormat();
        else if (typeof value === "object") handleDatesString(value);
    }
    return body;
};
